import { axiosInstance } from "./globals";
import * as userService from "./userService";
import { CustomerMeetingsCountRequest, DataSourceRequestSort, MeetingFilterOutputStatis, OutputSatisticRequest } from "@/model/filters";
import { DataSourceRequest, DataSourceRequestFilter } from "@/model/DataSourceRequest";
import * as util from "@/service/util";

import { DataSourceResult } from "@/model/DataSourceResult";
import { MeetingFilter } from "@/model/filters";
import moment from "moment";

import { jsPDF } from 'jspdf';
import autoTable from 'jspdf-autotable';

export async function getDashboardOverview() {
  const headers = userService.getAuthHeaders();
  return (await axiosInstance.get("/Reports/DashboardOverview", { headers })).data;
}

export async function getMeetingListToday() {
  const headers = userService.getAuthHeaders();
  return (await axiosInstance.get("/Reports/GetMeetingListToday", { headers })).data;
}
export async function getMeetingListDashboard(filter: MeetingFilter): Promise<DataSourceResult<any>> {
  const headers = userService.getAuthHeaders();

  const params = {
    fromDate: filter.fromDate,
    toDate: filter.toDate
  };
  const body: DataSourceRequest = {
    page: filter.page,
    pageSize: filter.pageSize,
    filters: [],
    sorts: [{ field: "CreatedAt", dir: "desc" }],
  };
  const isNumber = !isNaN(Number(filter.q));
  if (filter.status) {
    body.filters.push({
      field: "status", operator: "eq", value: filter.status, logic: "and"
    });
  }
  if (filter.isDeleted !== undefined) {
    body.filters.push({
      field: "isDeleted", operator: "eq", value: filter.isDeleted, logic: "and"
    });
  }
  if (filter.q) {
    const isNumber = !isNaN(Number(filter.q));
    const searchFilters: DataSourceRequestFilter[] = [
      { field: "name", operator: "contains", value: filter.q, logic: "or" }
    ];
    if (isNumber) {
      searchFilters.push(
        { field: "id", operator: "eq", value: Number(filter.q), logic: "or" },
        { field: "customerId", operator: "eq", value: Number(filter.q), logic: "or" }
      );
    }
    if (filter.status != null && body.filters.length > 0) {
      body.filters[0].filters = searchFilters;
    } else {
      body.filters.push(...searchFilters);
    }
  }
  return (await axiosInstance.post<DataSourceResult<any>>("/Reports/GetMeetingListDashboard", body, { headers, params })).data;
}

export async function getMeetingListDashboard_ExportExcel(filter: MeetingFilter): Promise<DataSourceResult<any>> {
  const headers = userService.getAuthHeaders();

  const params = {
    fromDate: filter.fromDate ? filter.fromDate : "",
    toDate: filter.toDate ? filter.toDate : ""
  };

  const body: DataSourceRequest = {
    page: filter.page,
    pageSize: filter.pageSize,
    filters: [],
    sorts: [{ field: "CreatedAt", dir: "desc" }],
  };
  if (filter.status) {
    body.filters.push({
      field: "status", operator: "eq", value: filter.status, logic: "and"
    });
  }
  if (filter.isDeleted !== undefined) {
    body.filters.push({
      field: "isDeleted", operator: "eq", value: filter.isDeleted, logic: "and"
    });
  }
  if (filter.q) {
    const isNumber = !isNaN(Number(filter.q));
    const searchFilters: DataSourceRequestFilter[] = [
      { field: "name", operator: "contains", value: filter.q, logic: "or" }
    ];
    if (isNumber) {
      searchFilters.push(
        { field: "id", operator: "eq", value: Number(filter.q), logic: "or" },
        { field: "customerId", operator: "eq", value: Number(filter.q), logic: "or" }
      );
    }
    if (filter.status != null && body.filters.length > 0) {
      body.filters[0].filters = searchFilters;
    } else {
      body.filters.push(...searchFilters);
    }
  }
  const response = await axiosInstance.post("/Reports/GetMeetingListDashboard/ExportExcel", body, {
    headers,
    params,
    responseType: 'text'
  });
  return response.data;
}

export async function getMeetingParticipants(fromDate: string, toDate: string) {
  const headers = userService.getAuthHeaders();
  const params = { fromDate, toDate };
  return (await axiosInstance.get("/Reports/GetMeetingParticipants", { headers, params })).data;
}

export async function getOutputStatistic_temp(filter: OutputSatisticRequest, isAdvanced?: boolean) {
  const headers = userService.getAuthHeaders();
  let params;
  if (isAdvanced) {
    params = {
      fromDate: filter.fromDate,
      toDate: filter.toDate,
      meetingFromDate: filter.meetingFromDate,
      meetingToDate: filter.meetingToDate
    };
  } else {
    params = {
      // fromDate: filter.fromDate,
      // toDate: filter.toDate,
      meetingFromDate: filter.meetingFromDate,
      meetingToDate: filter.meetingToDate
    };
  }
  const body: any = {
    page: filter.page,
    pageSize: filter.pageSize,
    filters: [],
    sorts: filter.sorts || []
  };

  // 
  const mainFilterGroup: Partial<DataSourceRequestFilter> = {
    logic: "and",
    filters: []
  };

  // ---  ---
  if (filter.saleAreaId) {
    mainFilterGroup.filters!.push({
      field: "saleAreaId",
      operator: "eq",
      value: filter.saleAreaId
    });
  }

  if (filter.provinceCode) {
    mainFilterGroup.filters!.push({
      field: "provinceCode",
      operator: "eq",
      value: filter.provinceCode
    });
  }

  if (filter.unitCode) {
    mainFilterGroup.filters!.push({
      field: "unitCode",
      operator: "eq",
      value: filter.unitCode
    });
  }

  if (filter.subPlanId) {
    mainFilterGroup.filters!.push({
      field: "subPlanId",
      operator: "eq",
      value: filter.subPlanId
    });
  }
  if (filter.sortField) {
    const newSort: DataSourceRequestSort = {
      field: filter.sortField,

      dir: "desc",
    };

    body.sorts.push(newSort);
  }

  if (filter.q) {
    const orGroup: Partial<DataSourceRequestFilter> = {
      logic: "or",
      filters: [
        { field: "name", operator: "contains", value: filter.q },
        // nếu muốn tìm thêm theo nhiều field khác, thêm ở đây
        // { field: "code", operator: "contains", value: filter.q }
      ]
    };

    mainFilterGroup.filters!.push(orGroup as DataSourceRequestFilter);
  }
  if (mainFilterGroup.filters && mainFilterGroup.filters.length > 0) {
    if (
      mainFilterGroup.filters.length === 1 &&
      (mainFilterGroup.filters[0] as any).logic === "or" &&
      Array.isArray((mainFilterGroup.filters[0] as any).filters)
    ) {
      body.logic = "or";
      body.filters = (mainFilterGroup.filters[0] as any).filters;
    } else {
      body.logic = "and";
      body.filters = mainFilterGroup.filters;
    }
  }
  const response = await axiosInstance.post(
    "/Reports/CustomerProductionStatistics",
    body,
    { headers, params }
  );
  return response.data;
}
export async function getOutputStatistic(filter: OutputSatisticRequest, unitCode?: string, isAdvanced?: boolean) {
  const headers = userService.getAuthHeaders();
  let params;
  if (isAdvanced) {
    params = {
      fromDate: filter.fromDate,
      toDate: filter.toDate,
      meetingFromDate: filter.meetingFromDate,
      meetingToDate: filter.meetingToDate,
      unitCode: unitCode
    };
  } else {
    params = {
      meetingFromDate: filter.meetingFromDate,
      meetingToDate: filter.meetingToDate,
      unitCode: unitCode
    };
  }
  const body: any = {
    page: filter.page,
    pageSize: filter.pageSize,
    filters: [],
    sorts: filter.sorts || []
  };
  const allFilters: any[] = [];
  if (filter.saleAreaId) {
    allFilters.push({
      field: "saleAreaId",
      operator: "eq",
      value: filter.saleAreaId
    });
  }
  if (filter.provinceCode) {
    allFilters.push({
      field: "provinceCode",
      operator: "eq",
      value: filter.provinceCode
    });
  }

  if (filter.subPlanId) {
    allFilters.push({
      field: "subPlanId",
      operator: "eq",
      value: filter.subPlanId
    });
  }
  // Xử lý filter.q
  if (filter.q) {
    allFilters.push({
      field: "name",
      operator: "contains",
      value: filter.q
    });
  }
  if (filter.sortField) {
    const newSort: DataSourceRequestSort = {
      field: filter.sortField,
      dir: "desc",
    };
    body.sorts.push(newSort);
  }
  // Xác định logic và gán filters
  if (allFilters.length > 0) {
    // Nếu có filter.q và không có filter bắt buộc -> dùng logic OR
    if (filter.q && !filter.saleAreaId && !filter.provinceCode && !filter.subPlanId) {
      body.logic = "or";
    }
    else {
      body.logic = "and";
    }

    body.filters = allFilters;
  }
  const response = await axiosInstance.post(
    "/Reports/CustomerProductionStatistics",
    body,
    { headers, params }
  );
  return response.data;
}

export async function getCustomerMeetingsCount(filter: CustomerMeetingsCountRequest) {
  const headers = userService.getAuthHeaders();

  const params = {
    fromDate: filter.fromDate,
    toDate: filter.toDate
  };
  const body: DataSourceRequest = {
    page: filter.page,
    pageSize: filter.pageSize,
    filters: [],
    sorts: filter.sorts
  };

  const filterCount = util.countPredicate([
    filter.q, filter.areaId
  ]);

  if (filter.q && filterCount === 1) {
    body.filters = [
      { field: "customerCode", operator: "contains", value: filter.q, logic: "or" },
      { field: "name", operator: "contains", value: filter.q, logic: "or" },
    ];

  } else {
    if (filter.areaId) {
      body.filters.push(
        { field: "areaId", operator: "eq", value: filter.areaId, logic: "and" }
      );
    }

    if (filter.q) {
      body.filters[0].filters = [
        { field: "customerCode", operator: "contains", value: filter.q, logic: "or" },
        { field: "name", operator: "contains", value: filter.q, logic: "or" },
      ];
    }
  }
  return (await axiosInstance.post("/Reports/CustomerMeetingsCount", body, { headers, params })).data;
}


export async function getCustomerMeetingsCountDetails(filter: CustomerMeetingsCountRequest) {
  const headers = userService.getAuthHeaders();

  const params = {
    fromDate: filter.fromDate,
    toDate: filter.toDate
  };
  const body: DataSourceRequest = {
    page: filter.page,
    pageSize: filter.pageSize,
    filters: [],
    sorts: filter.sorts
  };

  const filterCount = util.countPredicate([
    filter.q, filter.areaId
  ]);

  if (filter.q && filterCount === 1) {
    body.filters = [
      { field: "name", operator: "contains", value: filter.q, logic: "or" },
      { field: "customerAddress", operator: "contains", value: filter.q, logic: "or" },
    ];

  } else {
    if (filter.areaId) {
      body.filters.push(
        { field: "areaId", operator: "eq", value: filter.areaId, logic: "and" }
      );
    }

    if (filter.q) {
      body.filters[0].filters = [
        { field: "name", operator: "contains", value: filter.q, logic: "or" },
        { field: "customerAddress", operator: "contains", value: filter.q, logic: "or" },
      ];
    }
  }

  return (await axiosInstance.post("/Reports/CustomerMeetingCountDetails", body, { headers, params })).data;
}

export async function getMeetingsCountDetails(fromDate: string, toDate: string) {
  const headers = userService.getAuthHeaders();
  const params = { fromDate, toDate };

  return (await axiosInstance.get("/Reports/MeetingCountDetails", { headers, params })).data;
}

export async function getMeetingListByCustomerUser(filter: CustomerMeetingsCountRequest) {
  const headers = userService.getAuthHeaders();

  const params = {
    fromDate: filter.fromDate,
    toDate: filter.toDate
  };
  const body: DataSourceRequest = {
    page: filter.page,
    pageSize: filter.pageSize,
    filters: [],
    sorts: filter.sorts
  };

  const filterCount = util.countPredicate([
    filter.q, filter.areaId
  ]);

  if (filter.q && filterCount === 1) {
    body.filters = [
      { field: "User.Name", operator: "contains", value: filter.q, logic: "or" },
      { field: "Meeting.Name", operator: "contains", value: filter.q, logic: "or" },
    ];

  } else {
    if (filter.areaId) {
      body.filters.push(
        { field: "areaId", operator: "eq", value: filter.areaId, logic: "and" }
      );
    }

    if (filter.q) {
      body.filters[0].filters = [
        { field: "User.Name", operator: "contains", value: filter.q, logic: "or" },
        { field: "Meeting.Name", operator: "contains", value: filter.q, logic: "or" },
      ];
    }
  }
  return (await axiosInstance.post("/Meeting/GetMeetingListByCustomerUser", body, { headers, params })).data;
}

export async function getExportExcelByCustomerUser(filter: CustomerMeetingsCountRequest) {
  const headers = userService.getAuthHeaders();

  const params = {
    fromDate: filter.fromDate,
    toDate: filter.toDate
  };
  const body: DataSourceRequest = {
    page: filter.page,
    pageSize: filter.pageSize,
    filters: [],
    sorts: filter.sorts
  };

  const filterCount = util.countPredicate([
    filter.q, filter.areaId
  ]);

  if (filter.q && filterCount === 1) {
    body.filters = [
      { field: "User.Name", operator: "contains", value: filter.q, logic: "or" },
      { field: "Meeting.Name", operator: "contains", value: filter.q, logic: "or" },
    ];

  } else {
    if (filter.areaId) {
      body.filters.push(
        { field: "areaId", operator: "eq", value: filter.areaId, logic: "and" }
      );
    }

    if (filter.q) {
      body.filters[0].filters = [
        { field: "User.Name", operator: "contains", value: filter.q, logic: "or" },
        { field: "Meeting.Name", operator: "contains", value: filter.q, logic: "or" },
      ];
    }
  }
  return (await axiosInstance.post("/Meeting/GetMeetingListByCustomerUser/ExportExcel", body, { headers, params })).data;
}

export async function getErrorListDetails(type: string, domain: string, fromDate: string, toDate: string, page: number, pageSize: number, isExport: Boolean = false) {
  const headers = userService.getAuthHeaders();
  const params = { type, domain, fromDate, toDate };
  const body = {
    page: page,
    pageSize: pageSize,
  };
  if (!isExport)
    return (await axiosInstance.post("/ThongKe/getListErrorStats", body, { headers, params })).data;
  else
    return (await axiosInstance.post("/ThongKe/getListErrorStats/ExportExcel", body, { headers, params })).data;
}

export async function getstatsGeneral(type: string, domain: string, fromDate: string, toDate: string) {
  const headers = userService.getAuthHeaders();
  const params = { type, domain, fromDate, toDate };

  return (await axiosInstance.post("/ThongKe/getStatsGeneral", {}, { headers, params })).data;
}

export async function getAccountCreateList(fromDate: string, toDate: string, page: number, pageSize: number) {
  const headers = userService.getAuthHeaders();
  const params = { fromDate, toDate };
  const body = {
    page: page,
    pageSize: pageSize,
  };
  return (await axiosInstance.post("/reports/accountCreateList", body, { headers, params })).data;
}

export async function getMeetingCountDetails(type: string, fromDate: string, toDate: string) {
  const headers = userService.getAuthHeaders();
  const params = { type, fromDate, toDate };

  return (await axiosInstance.get("/reports/meetingCountDetails", { headers, params })).data;
}


export async function getCustomerSubListCount(fromDate: string, toDate: string, page: number, pageSize: number) {
  const headers = userService.getAuthHeaders();
  const params = { fromDate, toDate };
  const body = {
    page: page,
    pageSize: pageSize,
  };
  return (await axiosInstance.post("/reports/customerSubListCount", body, { headers, params })).data;
};
//#region Thống kê sản lượng 
//Over view
export async function getOutputStatictisOverView(meetingFromDate: string | null, meetingToDate: string | null, customerId: string) {
  const headers = userService.getAuthHeaders();

  // 1. Khởi tạo params với giá trị bắt buộc
  const params: any = { customerId };

  // 2. Kiểm tra nếu có giá trị thì mới thêm vào
  if (meetingFromDate) {
    params.meetingFromDate = meetingFromDate;
  }

  if (meetingToDate) {
    params.meetingToDate = meetingToDate;
  }

  console.log(params);
  return (await axiosInstance.get("/reports/CustomerDashboardOverview", { headers, params })).data;
}
//
export async function getChartDataByCustomerId(fromDate: string, toDate: string, customerId: string) {
  const headers = userService.getAuthHeaders();
  const params = { fromDate, toDate, customerId };
  return (await axiosInstance.get("/Reports/GetMeetingParticipants", { headers, params })).data;
}

// Meeting list for output statistic detail
export async function getMeetingListByCustomerId(
  customerId: number | string,
  filter: MeetingFilterOutputStatis,
  fromDate: string, toDate: string
): Promise<DataSourceResult<any>> {
  const headers = userService.getAuthHeaders();
  const params = { fromDate, toDate, customerId };
  const body: DataSourceRequest = {
    page: filter.page,
    pageSize: filter.pageSize,
    filters: [],
    sorts: [{ field: "id", dir: "desc" }],
  };
  if (filter.meetingStatus) {
    body.filters.push({
      field: "meetingStatus",
      operator: "eq",
      value: filter.meetingStatus,
      logic: "and",
    });
  }

  return (
    await axiosInstance.post<DataSourceResult<any>>(`/reports/MeetingProductionStatistics/`, body, {
      headers, params
    })
  ).data;
}
//#endregion 

//#region  xử lý xuất ra PDF

export async function exportFullPageToPDF(
  customerDetai: any, meetings: any[], statusTexts: { [key: string]: string; }, title: string, chartImage: string, chartWidth: number, chartHeight: number, labelTG: string, labelTL: string, labelTGia: string, labelPerMeeting: string, labelMeetDay: string, labelStorage: string) {
  const pdf = new jsPDF('p', 'mm', 'a2');

  try {
    // Load fonts first
    await loadFonts(pdf);

    // Add chart image and get the height used
    const chartHeightInPdf = addChartImage(pdf, chartImage, chartWidth, chartHeight);

    // Prepare table data
    const { tableData, tableColumns } = prepareTableData(meetings, statusTexts, labelTG, labelTL, labelTGia, labelPerMeeting, labelMeetDay, labelStorage);

    // Create table with proper positioning
    createTable(pdf, tableData, tableColumns, title, chartHeightInPdf);

    // Add page numbers and date
    addPageNumbers(pdf);

    // Save PDF
    const fileName = `NoiDungChinh_` + customerDetai.id + `_${moment().format('YYYYMMDD_HHmm')}.pdf`;
    pdf.save(fileName);
  } catch (e) {
    console.error('Error exporting PDF:', e);
    throw e;
  }
}
async function loadFonts(pdf: jsPDF) {
  try {
    // Load regular font
    const fontRegular = await fetchFont('fonts/Roboto-Regular.ttf');
    pdf.addFileToVFS('Roboto-Regular.ttf', fontRegular);
    pdf.addFont('Roboto-Regular.ttf', 'Roboto', 'normal');

    // Load bold font
    const fontBold = await fetchFont('fonts/Roboto-Bold.ttf');
    pdf.addFileToVFS('Roboto-Bold.ttf', fontBold);
    pdf.addFont('Roboto-Bold.ttf', 'Roboto', 'bold');

    console.log('✅ Font Roboto loaded successfully');

    // Set default font
    pdf.setFont('Roboto', 'normal');
  } catch (err) {
    console.warn('⚠️ Failed to load Roboto font, using default:', err);
    pdf.setFont('helvetica', 'normal');
  }
}

async function fetchFont(url: string): Promise<string> {
  try {
    const response = await fetch(url);
    if (!response.ok) throw new Error(`Font not found: ${url}`);

    const buffer = await response.arrayBuffer();
    const uint8Array = new Uint8Array(buffer);

    // Convert to base64 with proper chunking
    let binary = '';
    const chunkSize = 0x8000; // 32KB
    for (let i = 0; i < uint8Array.length; i += chunkSize) {
      binary += String.fromCharCode.apply(null,
        uint8Array.subarray(i, i + chunkSize)
      );
    }

    return btoa(binary);
  } catch (error) {
    console.error('Error loading font:', error);
    throw error;
  }
}

function addChartImage(pdf: jsPDF, imageBase64: string, width: number, height: number): number {
  const pageWidth = pdf.internal.pageSize.getWidth();
  const margin = 10;
  const imgWidth = pageWidth - margin * 2;
  const imgHeight = (height * imgWidth) / width;

  // Add image with proper positioning
  pdf.addImage(imageBase64, 'PNG', margin, margin, imgWidth, imgHeight);

  // Return the height used by the image plus margin
  return imgHeight + margin * 2; // Add margin after image
}
function prepareTableData(meetings: any[], statusTexts: { [key: string]: string }, labelTG: string, labelTL: string, labelTGia: string, labelperMeeting: string, labelMeetDay: string, labelStorage: string) {
  const tableData = meetings.map((item, index) => {
    const statusText = statusTexts[item.meetingStatus] || item.meetingStatus;


    const timeInfo = [
      item.startTime || null,
      item.meetingTime ? `${labelTG}: ${item.meetingTime}` : null,
      util.formatMinutesToHhMmSS(item.duration) ? `${labelTL}: ${util.formatMinutesToHhMmSS(item.duration)}` : null,
      item.actualParticipantCount ? `${labelTGia}: ${item.actualParticipantCount}` : null,
    ].filter(Boolean).join('\n');

    const planInfo = [
      item.subscriptionPlanName || null,
      item.meetingConcurrentParticipantsLimit ? `${item.meetingConcurrentParticipantsLimit} ${labelperMeeting}` : null,
      item.meetingCountDailyLimit ? `${item.meetingCountDailyLimit} ${labelMeetDay}` : null,
      item.maxStorageSize ? `${labelStorage}: ${util.smartBytesToUnit(item.maxStorageSize)}` : null,
    ].filter(Boolean).join('\n');

    const sizeInfo = item.recordingSize ? util.smartBytesToUnit(item.recordingSize) : '';
    const sizeInfomation = util.getLabelForRecord(item, " Có", " Không");
    const sumInfo = util.getLabelForSum(item, " Có", " Không");
    return [
      index + 1,
      item.id,
      item.name || '',
      timeInfo,
      sizeInfomation,
      sumInfo,
      planInfo,
      item.createdAt || '',
      item.deletedByName || '',
      statusText,
      item.meetingStatus
    ];
  });

  const tableColumns = [
    { header: 'STT' },
    { header: "ID" },
    { header: statusTexts['meeting'] || 'Meeting' },
    { header: statusTexts['meetingDate'] || 'Meeting Date' },
    { header: statusTexts['capacity'] || 'Capacity' },
    { header: statusTexts['aiGen'] || 'AI Generated' },
    { header: statusTexts['package'] || 'Package' },
    { header: statusTexts['createBy'] || 'Created By' },
    { header: statusTexts['deleteBy'] || 'Deleted By' },
    { header: statusTexts['status'] || 'Status' },
  ];

  return { tableData, tableColumns };
}

function createTable(pdf: jsPDF, tableData: any[], tableColumns: any[], title: string, startY: number) {
  // Set font before adding title
  pdf.setFont('Roboto', 'bold');
  pdf.setFontSize(12);
  const pageWidth = pdf.internal.pageSize.getWidth();
  pdf.text(title, pageWidth / 2, 10, { align: 'center' });

  // Reset font for table
  pdf.setFont('Roboto', 'normal');
  pdf.setFontSize(10);

  autoTable(pdf, {
    head: [tableColumns.map(col => col.header)],
    body: tableData,
    startY: startY - 10,
    styles: {
      font: 'Roboto',
      fontSize: 9,
      fontStyle: 'normal',
      cellPadding: 1,
      lineWidth: 0.1,
      overflow: 'linebreak',
      valign: 'middle',
      lineColor: "#fff"
    },
    headStyles: {
      fillColor: [0, 79, 158],
      textColor: [255, 255, 255],
      fontStyle: "bold",
      cellPadding: 1
    },
    theme: 'plain',
    margin: { top: 20, left: 14, right: 14, bottom: 20 },

    columnStyles: {
      0: { cellWidth: 12, halign: 'center' },
      1: { cellWidth: 15, halign: 'left' },
      2: { cellWidth: 80, overflow: 'linebreak' },
      3: { cellWidth: 'auto', halign: 'left' },
      4: { cellWidth: 'auto', halign: 'left' },
      5: { cellWidth: 'auto', overflow: 'linebreak' },
      6: { cellWidth: 'auto' },
      7: { cellWidth: 'auto' },
      8: { cellWidth: 'auto' },
      9: { cellWidth: 'auto' },
    },

    tableWidth: 'auto',

    didParseCell: (data) => {
      if (data.section === 'body' && data.column.index === 9) {
        const meetingStatus = data.row.raw[10];

        switch (meetingStatus) {
          case 'END':
            data.cell.styles.textColor = [64, 64, 64];
            data.cell.styles.fontStyle = "bold";
            break;
          case 'INPROGRESS':
            data.cell.styles.textColor = [0, 128, 0];
            data.cell.styles.fontStyle = "bold";
            break;
          case 'PENDING':
            data.cell.styles.textColor = [255, 165, 0];
            data.cell.styles.fontStyle = "bold";
            break;
          case 'CANCEL':
            data.cell.styles.textColor = [255, 0, 0];
            data.cell.styles.fontStyle = "bold";
            break;
          default:
            data.cell.styles.textColor = [0, 0, 0];
            data.cell.styles.fontStyle = "bold";
        }
      }
    },

    didDrawPage: (data) => {
      // Title is already added at the top
    },
  });
}

function addPageNumbers(pdf: jsPDF) {
  const pageCount = pdf.internal.pages.length - 1;

  for (let i = 1; i <= pageCount; i++) {
    pdf.setPage(i);
    const pageWidth = pdf.internal.pageSize.getWidth();
    const pageHeight = pdf.internal.pageSize.getHeight();
    const margin = 10;

    pdf.setLineWidth(0.1);
    pdf.line(margin, pageHeight - 15, pageWidth - margin, pageHeight - 15);

    pdf.setFont('Roboto', 'normal');
    pdf.setFontSize(10);
    const footerText = `${i} / ${pageCount}`;
    pdf.text(
      footerText,
      pageWidth - margin,
      pageHeight - margin,
      { align: 'right' }
    );

    const currentDate = moment().format('DD/MM/YYYY');
    pdf.text(
      `${currentDate}`,
      margin,
      pageHeight - margin
    );
  }
}
//#endregion

//#region xuất file excell chi tiết sản lượng - danh sách meetings
// reportService.ts
import * as XLSX from 'xlsx';
import { smartBytesToUnit, formatMinutesToHhMmSS } from './util';

export async function exportMeetingsListToExcel(
  customerId: number,
  customerName: string,
  filterStatus: string | null,
  startDate: Date | null,
  endDate: Date | null,
  translations: Record<string, string>,
  getStatusTranslate: (status: string) => string
) {
  try {
    // Lấy tất cả meetings
    const allMeetings = [];
    const pageSize = 500;
    let page = 1;

    while (true) {
      const meetingListRes = await getMeetingListByCustomerId(
        customerId,
        {
          meetingStatus: filterStatus,
          page,
          pageSize
        },
        startDate?.toISOString(),
        endDate?.toISOString()
      );

      const part: any[] = Array.isArray(meetingListRes.data) ? meetingListRes.data : [];
      allMeetings.push(...part);
      if (part.length < pageSize || page >= meetingListRes.total) break;
      page++;
    }

    // Chuẩn bị dữ liệu cho sheet
    const sheetData = prepareSheetData(allMeetings, translations, getStatusTranslate);

    // Tạo workbook và sheet
    const workbook = XLSX.utils.book_new();
    const sheet = XLSX.utils.aoa_to_sheet(sheetData);

    // Thiết lập độ rộng cột
    setupColumnWidths(sheet, sheetData);

    // Thêm sheet vào workbook
    XLSX.utils.book_append_sheet(workbook, sheet);

    // Tạo tên file và lưu
    const fileName = `ChiTiet_DanhSach_CuocHop_${customerId}_${customerName}.xlsx`;
    XLSX.writeFile(workbook, fileName);

    return fileName;
  } catch (error) {
    console.error('Error exporting meetings list to Excel:', error);
    throw error;
  }
}

function prepareSheetData(
  meetings: any[],
  translations: Record<string, string>,
  getStatusTranslate: (status: string) => string
): any[][] {
  // Tạo tiêu đề
  const headerRow = [
    "STT",
    "Id",
    translations.meetingName,
    translations.createDate,
    translations.meetingDate,
    translations.meetingTime,
    translations.duration,
    translations.participantCount,
    translations.package,
    translations.allowedCapacity,
    translations.recordingCapacity,
    translations.summaryDuration,
    translations.IdKH,
    translations.creatorAccount,
    translations.status,
    translations.deletedAccount
  ];

  // Tạo dữ liệu
  const dataRows = meetings.map((item, index) => [
    index + 1,
    item.id,
    item.name,
    item.createdAt,
    item.startTime,
    item.meetingTime,
    formatMinutesToHhMmSS(item.duration),
    item.actualParticipantCount,
    item.subscriptionPlanName,
    smartBytesToUnit(item.maxStorageSize),
    smartBytesToUnit(item.recordingSize),
    formatMinutesToHhMmSS(item.summaryDuration),
    item.customerId,
    item.createdByName,
    getStatusTranslate(item.meetingStatus),
    item.deletedByName
  ]);

  // Tạo sheet data với tiêu đề chính và tiêu đề bảng
  const sheetData = [
    [translations.meetingList],
    headerRow,
    ...dataRows
  ];

  return sheetData;
}

function setupColumnWidths(sheet: XLSX.WorkSheet, sheetData: any[][]) {
  const headerRow = sheetData[1]; // Header row is at index 1
  const columnWidths = headerRow.map((header, colIndex) => {
    // Cột tên cuộc họp (index 2) có độ rộng cố định
    if (colIndex === 2) {
      return { wpx: 300 };
    }

    // Tính toán độ rộng cho các cột khác
    let maxWidth = String(header).length;
    for (let i = 2; i < sheetData.length; i++) {
      const cellValue = sheetData[i][colIndex];
      if (cellValue !== undefined && cellValue !== null) {
        maxWidth = Math.max(maxWidth, String(cellValue).length);
      }
    }
    return { wch: maxWidth + 2 }; // Thêm khoảng trống
  });

  sheet['!cols'] = columnWidths;
}
//==== Xuất excel chi tiết sản lượng chung
export async function exportOutputStatisticToExcel(
  params: {
    fromDate?: Date | null;
    toDate?: Date | null;
    meetingFromDate?: Date | null;
    meetingToDate?: Date | null;
    q?: string;
    saleAreaId?: number | null;
    unitCode?: string | null,
    areaOption?: string | null

  },
  translations: Record<string, string>
) {
  try {
    // Validate date range
    if (params.fromDate && params.toDate && params.fromDate.getTime() > params.toDate.getTime()) {
      throw new Error(translations.invalidDateRange);
    }

    // Lấy tất cả dữ liệu khách hàng
    const customers = [];
    const pageSize = 1000;
    let page = 1;

    while (true) {
      const customerListRes = await getOutputStatistic({
        fromDate: params.fromDate ? params.fromDate.toISOString() : null,
        toDate: params.toDate ? params.toDate.toISOString() : null,
        meetingFromDate: params.meetingFromDate ? params.meetingFromDate.toISOString() : null,
        meetingToDate: params.meetingToDate ? params.meetingToDate.toISOString() : null,
        page,
        pageSize,
        q: params.q?.trim(),
        saleAreaId: params.saleAreaId,
        provinceCode: params.areaOption,
      }, params.unitCode as string);

      const part: any[] = Array.isArray(customerListRes.data) ? customerListRes.data : [];
      customers.push(...part);
      if (part.length < pageSize) break;
      page++;
    }

    // Chuẩn bị dữ liệu cho sheet
    const sheetData = prepareOutputStatisticSheetData(customers, params, translations);

    // Tạo workbook và sheet
    const workbook = XLSX.utils.book_new();
    const sheet = XLSX.utils.aoa_to_sheet(sheetData);

    // Thiết lập độ rộng cột
    setupOutputStatisticColumnWidths(sheet, sheetData);

    // Thêm sheet vào workbook
    XLSX.utils.book_append_sheet(workbook, sheet);

    // Tạo tên file và lưu
    const fileName = "ThongKeChiTietSoLuongCuocHop.xlsx";
    XLSX.writeFile(workbook, fileName);

    return fileName;
  } catch (error) {
    console.error('Error exporting output statistic to Excel:', error);
    throw error;
  }
}

function prepareOutputStatisticSheetData(
  customers: any[],
  params: {
    fromDate?: Date | null;
    toDate?: Date | null;
  },
  translations: Record<string, string>
): any[][] {
  // Tạo tiêu đề chính
  const titleRow = [
    translations.meetingStatistics + " " +
    translations.fromDate + " " +
    (params.fromDate ? moment(params.fromDate).format("DD/MM/YYYY") : '') +
    " - " +
    translations.toDate + " " +
    (params.toDate ? moment(params.toDate).format("DD/MM/YYYY") : '')
  ];

  // Tạo tiêu đề bảng
  const headerRow = [
    "STT",
    translations.IdKH,
    translations.name,
    translations.phoneNumber,
    translations.email,
    translations.address,
    translations.saleArea,
    translations.unitDepart,
    translations.thoidiemtao,
    translations.goicuoc,
    translations.fromDate,
    translations.toDate,
    translations.songayconlai,
    translations.totalMeetings,
    translations.totalActualDuration,
    translations.totalMeetingsRecorded,
    translations.totalRecordingSize,
  ];

  // Tạo dữ liệu
  const dataRows = customers.map((it, index) => [
    index + 1,
    it.customerCode,
    it.name,
    it.phoneNumber,
    it.email,
    '', // Address column is empty
    it.saleAreaName,
    it.unitName,
    moment(it.createdTime).format("DD/MM/YYYY HH:mm"),
    it.subPlanName,
    it.cusSubStartDate ? moment(it.cusSubStartDate).format("DD/MM/YYYY") : '',
    it.cusSubEndDate ? moment(it.cusSubEndDate).format("DD/MM/YYYY") : '',
    it.remainingDays,
    it.totalMeetings,
    formatMinutesToHhMmSS(it.totalActualDuration),
    it.totalMeetingsRecorded,
    smartBytesToUnit(it.totalRecordingSize),
  ]);

  // Tạo sheet data với tiêu đề chính và tiêu đề bảng
  const sheetData = [
    titleRow,
    headerRow,
    ...dataRows
  ];

  return sheetData;
}

function setupOutputStatisticColumnWidths(sheet: XLSX.WorkSheet, sheetData: any[][]) {
  // Tính toán độ rộng cột dựa trên dữ liệu
  const colWidths = sheetData.slice(1).reduce((acc, row) => {
    row.forEach((cell, i) => {
      const cellValue = cell == null ? '' : cell.toString();
      const cellLength = cellValue.length + 2;
      if (!acc[i] || cellLength > acc[i]) {
        acc[i] = Math.min(cellLength, 50); // Giới hạn tối đa 50 ký tự
      }
    });
    return acc;
  }, []);

  sheet['!cols'] = colWidths.map(w => ({ wch: w }));
}
//#endregion